export default __webpack_public_path__ + "static/media/home-page-header-bg-mobile.b1084607.png";